export enum ScriptLoaderEvents {
    ScriptLoaded = 'scriptLoaded',
    ScriptLoadedError = 'scriptLoadError'
}
